import { render, staticRenderFns } from "./exhibition-home.vue?vue&type=template&id=3f81d0ac&scoped=true&"
import script from "./exhibition-home.vue?vue&type=script&lang=js&"
export * from "./exhibition-home.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-home.vue?vue&type=style&index=0&id=3f81d0ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f81d0ac",
  null
  
)

export default component.exports